import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData } from 'src/utils/axios/serverHelper';
import { formatDate } from 'src/utils/string/stringUtil';

import { SYS5020_R01Dto, SYS5020_R01Filter } from './Dto_SYS5020_R01';

const baseUrl = `${config.apiUrl}/SYS5020_R01`;

const getParams = (filter: Partial<SYS5020_R01Filter>) => ({
    startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
    endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
    searchUserId: filter.userId || undefined,
    searchProgramId: filter.programId || undefined,
    searchActionType: filter.actionType || undefined,
});

export const getSYS5020_R01List = async (
    option: string,
    params: Partial<SYS5020_R01Filter>,
) => {
    return await getData<ResponseDto<SYS5020_R01Dto[]>>(`${baseUrl}/${option}`, {
        params: getParams(params),
    });
};

export const getSYS5020_R01AllCount = async (params: Partial<SYS5020_R01Filter>) => {
    return await getData<ResponseDto<number>>(`${baseUrl}/allCount`, {
        params: getParams(params),
    });
};

export const downloadExcel_SYS5020_R01 = async (
    option: string,
    params: Partial<SYS5020_R01Filter>,
) => {
    return await getData<ResponseDto<string>>(`${baseUrl}/excel/${option}`, {
        params: getParams(params),
    });
};
